import './NotificationsSection.scss';

import { ArrowLeftOutlined } from '@ant-design/icons';
import { useList } from '@refinedev/core';
import { useDocumentTitle as useDocTitle } from '@refinedev/react-router';
import { Badge, Button, Empty } from 'antd';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import SpinLoading from '@/components/general/SpinLoading';
import { useUserContext } from '@/contexts/UserContext';
import { UserNotification } from '@/model/General/Notification';
import { queryKeys } from '@/repositories/queryKeys';

import NotificationsList from './NotificationsList';

const NotificationsSection = () => {
  const { unreadNotifications } = useUserContext();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;

  useDocTitle('Notificaciones | Acronex');

  const {
    result: { data: notifications, total },
    query: { isLoading, refetch },
  } = useList<UserNotification>({
    queryOptions: {
      queryKey: queryKeys.notifications.headerNotifications(), // Clave de consulta específica para las notificaciones del encabezado
    },
    resource: 'notifications',
    pagination: {
      currentPage,
      pageSize,
      mode: 'server',
    },
  });
  const hasNotifications = (notifications?.length ?? 0) > 0;

  return (
    <div className="NotificationsSection MainSection">
      <div className="NotificationsSectionHeader">
        <Button icon={<ArrowLeftOutlined />} onClick={() => void navigate(-1)} type="text" />
        <h2 className="NotificationsSectionTitle">Notificaciones</h2>
        <Badge count={unreadNotifications} title="Sin leer" />
      </div>

      {hasNotifications ? (
        <NotificationsList
          notifications={notifications ?? []}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageSize={pageSize}
          total={total}
          refetch={() => void refetch()}
        />
      ) : isLoading ? (
        <SpinLoading />
      ) : (
        <div className="NotificationsSectionEmpty">
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="No hay notificaciones todavía. Te avisaremos cuando haya novedades."
          />
        </div>
      )}
    </div>
  );
};

export default NotificationsSection;
